import _Promise from '@babel/runtime-corejs3/core-js/promise';
import _ from 'lodash-es';

var DEFAULT_RETRY_TIMES = 3; // TODO: 改为仅在网络不佳或有需要时再重新请求接口，参考 https://github.com/MiaoSiLa/missevan-standalone/pull/1122#discussion_r1155587716

var requestWithRetry = function requestWithRetry(request) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    maxRetryTimes: DEFAULT_RETRY_TIMES,
    wait: 1000
  },
      maxRetryTimes = _ref.maxRetryTimes,
      wait = _ref.wait;

  var retryTimes = 0; // TODO: 改为预设一些延迟重新请求的策略，由使用者传参进行选择

  var getDelayTime = function getDelayTime(delay, times) {
    return delay + times * 1000;
  };

  var doRequest = function doRequest(_ref2) {
    var resolve = _ref2.resolve,
        reject = _ref2.reject;
    return request().then(function (res) {
      resolve(res);
    }).catch(function (err) {
      if (retryTimes >= maxRetryTimes) {
        reject(err);
        return;
      }

      _.delay(function () {
        return doRequest({
          resolve: resolve,
          reject: reject
        });
      }, getDelayTime(wait, retryTimes));

      retryTimes += 1;
    });
  };

  return new _Promise(function (resolve, reject) {
    doRequest({
      resolve: resolve,
      reject: reject
    });
  });
};

export { requestWithRetry };
